import { CircleCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface FeedbackConfirmationProps {
  onClose: () => void;
}

export function FeedbackConfirmation({ onClose }: FeedbackConfirmationProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-6 py-8 text-center">
      <CircleCheck className="h-16 w-16 text-primary" />

      <p className="text-lg font-medium">{t('Feedback.confirmation.message')}</p>

      <button
        type="button"
        onClick={onClose}
        className="rounded-lg bg-primary px-6 py-3 text-primary-foreground font-medium transition-colors hover:bg-primary/90"
      >
        {t('Feedback.confirmation.close')}
      </button>
    </div>
  );
}
